import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

interface CloseButtonProps {
  onClicked: () => void;
  disabled?: boolean;
}

export function CloseButton({
  onClicked,
  disabled,
}: CloseButtonProps): JSX.Element {
  if (disabled) {
    return (
      <IconButton disabled={true}>
        <CloseIcon />
      </IconButton>
    );
  }
  return (
    <IconButton onClick={onClicked}>
      <CloseIcon />
    </IconButton>
  );
}
